import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookingForm.html?raw';
import ResourcePicker from '../../moreCore/UI/ResourcePicker/ResourcePicker';
import "../../moreCore/UI/ResourcePicker/ResourcePicker";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import "../../moreCore/UI/SearchSelect/SearchSelect";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import TiBookingSummary from '../TransportIntermodal/BookingSummary';
import "../TransportIntermodal/BookingSummary";
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import "../../moreCore/UI/CheckBox/CheckBox";
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import TiTransportGoodView from './TransportGoodView';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import TiTransportGoodManager from './TransportGoodsManager';
import "./TransportGoodsManager";

import UnloadingList from '../Wizards/TransportIntermodal/UnloadingList';
import "../Wizards/TransportIntermodal/UnloadingList";
import TiRouteSectionCombinator from './Route/SectionCombinator/SectionCombinator';
import TiMainRouteView from './Route/MainRouteView';
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import { TiEntities, TiInterfaces } from "./TiTypes";


interface OffloadingEntry { label: string, value: number };
class TiBookingForm extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    bookingMode: "default" | "rebook" = "default";

    private slotpickerContainer_logistic: HTMLElement;
    private slotpickerContainer_route: HTMLElement;
    public sectionStep1: HTMLElement;
    public sectionStep2: HTMLElement;
    public sectionStep3: HTMLElement;
    public sectionStep4: HTMLElement;
    public sectionDispo: HTMLElement;
    public sectionBookingConfirmation: HTMLElement;
    public sectionBookingSummary: HTMLElement;
    public sectionTransportGood: HTMLElement;
    public transportGoodInfoContainer: HTMLElement;
    private routeResourceWarning: HTMLElement;
    //private sectionAdditionalTransportGoods: HTMLElement;
    //private freightOccupationContainer: HTMLElement;

    private page_routeSlots: HTMLElement;
    private page_customRoute: HTMLElement;
    private page_routeView: HTMLElement;

    private customRouteContainer: HTMLElement;
    private routeViewContainer: HTMLElement;
    //private btnCreateCustomRoute: HTMLElement;
    //private btnRemoveCustomRoute: HTMLElement;
    private removeRouteContainer: HTMLElement;


    private pageStackContainer_route: HTMLElement;
    private pageStack_route: MdsLax<InstanceType<typeof PageStack>>;

    private inputTransportGoodPreselect: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputTransportGood: MdsLax<InstanceType<typeof SearchSelect>>;
    private transportGoodExpanderPreselect: MdsLax<InstanceType<typeof ExpandableSection>>;
    private transportGoodExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    //private freightOccupationViewLDM: TiFreightOccupationView;
    //private freightOccupationViewWeight: TiFreightOccupationView;
    private transportGoodsManager: MdsLax<InstanceType<typeof TiTransportGoodManager>>; // raus aus der Bookingform und dann eigenständig in BookingSummary?!
    private unloadingList: MdsLax<InstanceType<typeof UnloadingList>>;

    private inputOrderNo: HTMLInputElement;
    //private inputSearchOrderNo: Edit;
    private inputMainRoute: MdsLax<InstanceType<typeof SearchSelect>>;
    private isCustomMainRoute: boolean = false;
    private inputDivision: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputTerminal: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputOffloading: MdsLax<InstanceType<typeof SearchSelect>>;
    private logisticResourcesPicker: MdsLax<InstanceType<typeof ResourcePicker>>;
    private routeResourcesPicker: MdsLax<InstanceType<typeof ResourcePicker>>;
    private bookingSummary: MdsLax<InstanceType<typeof TiBookingSummary>>;
    private cbShowEmptyDaysOnRouteSlots: MdsLax<InstanceType<typeof CheckBox>>;
    private cbFilterTerminal: MdsLax<InstanceType<typeof CheckBox>>;
    private filterTerminalContainer: HTMLElement;
    private orderNoContainer: HTMLElement;

    private btnBook: HTMLButtonElement;
    private btnRebook: HTMLButtonElement;
    private btnReserve: HTMLButtonElement;
    private btnCancel: HTMLButtonElement;

    private progressBar: HTMLElement;

    private entity: TiEntities.BookingEntityData;
    private entityID: string;
    private transportGoodID: string;
    private transportGood: TiEntities.TransportGoodEntity;
    private isCancelled: boolean = false;
    private divisionID: string;
    private terminalID: string;
    private logisticResourceID: string;
    private logisticResource: TiEntities.LogisticResource;
    private mainRouteID: string;
    private routeslotID: string;
    private offloading: number = -1;
    private orderNo: string;

    private logisticResourcesRegistry: Array<TiEntities.LogisticResource> = [];
    private logisticResourcesGroupsRegistry: Array<ResourcePicker.GroupDescriptor> = [];
    private routeResourcesRegistry: Array<TiInterfaces.RouteResource> = [];
    private terminalsRegistry: Array<{ ID: string, name_address: string }> = [];
    private divisionsRegistry: Array<{ ID: string, name_address: string }> = [];

    step1_Valid: boolean = false;
    //step1_Value: string;
    step1_Summary: string;

    step2_Valid: boolean = false;
    //step2_Value: string;
    step2_Summary: string;

    step3_Valid: boolean = false;
    //step3_Value: string;
    step3_Summary: string;

    step4_Valid: boolean = false;
    //step4_Value: string;
    step4_Summary: string;

    step5_Valid: boolean = false;

    step6_Valid: boolean = false;


    private previousFormdata: string;

    private formData: TiInterfaces.BookingFormData & TiInterfaces.BookingFormData_CustomRoute = null;

    private loadDivisions(): void {

        this.hourGlassStart(this.inputDivision);
        //this.inputDivision.StandbyStart();

        var url = window.appRoot + "TransportIntermodal/LoadDivisions";

        let data = {

        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadDivisionsResponse),
            lang.hitch(this, this._onLoadDivisionsError),
            false // sync
        );
    }

    private _onLoadDivisionsResponse(response: Array<TiEntities.DivisionEntity>) {
        this.hourGlassEnd(this.inputDivision);
        let result = false;
        for (let entity of response) {
            if (entity.ID == this.divisionID) {
                result = true;
                break;
            }
        }

        if (result != true) {
            this.divisionID = null;
        }

        this.inputDivision.setSelectionListLEGACY(response);
        this.inputDivision.setValue(this.divisionID);

        this.divisionsRegistry = response;
    }

    private _onLoadDivisionsError(error: more.requestErrorMessage) {
        this.hourGlassEnd(this.inputDivision);
        this.showMessage("loading divisions failed", error.Message, true);

        //alert(error.Message);

    }

    _setDivisionAttr(ID: string) {
        this._onChange_InputDivision(ID);
    }
    private _onChange_InputDivision(value: string) {
        //console.debug("_onChange_InputDivision", value);
        localStorage.setItem("Ti_DivisionID", value);

        this.divisionID = value;

        if (this.entityID) return;

        this.setTransportGood(null);
        this.disableNode(this.inputTransportGoodPreselect, !this.divisionID);
        this.disableNode(this.inputTransportGood, !this.divisionID);

        this.setStep1Data(value, null, this.transportGoodID);

        //this.setupTransportGoodResourcePicker();
        this.loadTransportGoods();


        if (this.divisionID) {
            //this.inputTerminal.setValue(null);
            this.loadTerminalsDelayed();
        }

    }
    private _transportGoodRequest: any = null;
    private loadTransportGoods() {

        if (this._transportGoodRequest) {
            this._transportGoodRequest.cancel();
            this._transportGoodRequest = null;
        }

        if (!this.divisionID) {
            return;
        }
        this.inputTransportGoodPreselect.hourGlassStart();
        this.inputTransportGood.hourGlassStart();

        this._transportGoodRequest = this.RequestManager.callfunction("Webtool_API_TransportIntermodal__GetTransportGoods",
            {
                divisionID: this.divisionID,
                selectedTransportGoodID: this.transportGoodID
            //    orderNo: this.inputSearchOrderNo.getValue()
            },
            lang.hitch(this, this._onLoadTransportGoods),
            lang.hitch(this, this._onLoadTransportGoodsError));
    }

    private _onLoadTransportGoods(response: more.PackedEntitylistResult<TiEntities.TransportGoodEntity>) {
        //let resultTable = new StaticTable();
        //resultTable.
        //resultTable.placeAt(this.transportGoodResourceContainer, "only");
        //resultTable.setRowClick(lang.hitch(this, this._onClick_TransportGood));
        //resultTable.addLineConfig({
        //    attributes: ["order_number", "ref_country.name"],
        //    colNamesInternal: ["orderNo", "country"],
        //    headings: ["#", "country"]
        //});

        //resultTable.setData(response);
        this.inputTransportGood.hourGlassEnd();
        this.inputTransportGoodPreselect.hourGlassEnd();

        this.inputTransportGoodPreselect.setSelectionListLEGACY(response.entitylist);
        this.inputTransportGood.setSelectionListLEGACY(response.entitylist);

        if (this.transportGoodID) {
            this.inputTransportGoodPreselect.setValue(this.transportGoodID, true);
            this.inputTransportGood.setValue(this.transportGoodID, true);
        }
    }

    private _onLoadTransportGoodsError(error: more.requestErrorMessage) {
        alert(error.Message);
        this.inputTransportGood.hourGlassEnd();
        this.inputTransportGoodPreselect.hourGlassEnd();
    }

    private _onChange_InputTransportGoodPreselect(value: string) {
        let entity: TiEntities.TransportGoodEntity = this.inputTransportGoodPreselect.getValue(true);

        if (entity?.ID != this.transportGoodID) {
            this.setTransportGood(entity);
        }
    }
    private _onChange_InputTransportGood(value: string) {
        let entity: TiEntities.TransportGoodEntity = this.inputTransportGood.getValue(true);
        this.transportGood = entity;
        this.transportGoodID = entity?.ID;

        this.inputTransportGoodPreselect.setValue(value);

        this.serializeData();

        this.disableNode(this.btnBook, !this.transportGoodID);
        this.updateTransportGoodViews(entity);

    }

    private updateTransportGoodViews(entity: TiEntities.TransportGoodEntity) {
        if (this.transportGoodID) {
            //this.transportGoodsManager.blacklistTransportGood(this.transportGoodID);
        }

        if (entity) {
            let tgInfo = new TiTransportGoodView();
            tgInfo.setData(entity);
            //tgInfo.placeAt(this.transportGoodInfoContainer, "only");
            this.transportGoodExpanderPreselect.setup("", this.createFontawesomeIcon("fa-solid fa-boxes-packing", "&nbsp;").outerHTML + entity.order_number);
            this.transportGoodExpanderPreselect.setContent(tgInfo);
            //this.transportGoodExpanderPreselect.toggleExpand(false);

            this.transportGoodExpander.setup("", this.createFontawesomeIcon("fa-solid fa-boxes-packing", "&nbsp;").outerHTML + entity.order_number);
            this.transportGoodExpander.setContent(lang.clone(tgInfo.domNode));
            //this.transportGoodExpander.toggleExpand(true);
        }

        this.transportGoodExpander.setMarking(entity ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.hidden);
        this.transportGoodExpanderPreselect.setMarking(entity ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.hidden);

    }

    setTransportGood(entity: TiEntities.TransportGoodEntity) {
        if (this.transportGoodID == entity?.ID) return;

        this.inputTransportGood.setReadonly(!!entity);
        this.inputTransportGood.setValue(entity);

        //this.transportGoodsManager.blacklistTransportGood(entity?.ID);

        this.UiModder.domConstruct.empty(this.transportGoodInfoContainer);
        //this.hideNode(this.transportGoodInfoContainer, !entity);

        // falls das Entity schon existiert nicht so viel Wirbel machen
        if (!this.entityID && this.bookingMode != "rebook") {
            this.setStep1Data(this.divisionID, this.terminalID, entity?.ID);
        }

        //this.emit("transportGoodChanged", entity);
        this.disableNode(this.inputOrderNo, !!entity);

        this.inputOrderNo.value = entity ? entity.order_number : "";
        this.inputTransportGood.setValue(entity);

        this.hideNode(this.filterTerminalContainer, !this.transportGoodID);

        if (entity) this.inputTerminal.setValue(null);
        this.loadTerminalsDelayed();
    }

    private _onChange_FilterTerminal(newValue: boolean) {
        if (this.entityID) return;

        this.inputTerminal.setValue(null);
        this.loadTerminalsDelayed();
    }

    private _terminalLoadRequest: any = null;
    private loadTerminalsDelayed(delay: number = 30): void {
        if (!this.divisionID) return;
        if (this.entityID) return;

        if (this._terminalLoadRequest) {
            clearTimeout(this._terminalLoadRequest);
        }

        this._terminalLoadRequest = setTimeout(lang.hitch(this, this._loadTerminals), delay);
    }

    _loadTerminals() {
        this.hourGlassStart(this.inputTerminal);

        let data = {
            "divisionID": this.divisionID,
            "filterByTransportGood": !!this.transportGoodID && this.cbFilterTerminal.getValue(),
            "transportGoodID": this.transportGoodID
        };

        this.RequestManager.callfunction(
            "Webtool_API_TransportIntermodal__LoadStartTerminals",
            data,
            lang.hitch(this, this._onLoadTerminalsResponse),
            lang.hitch(this, this._onLoadTerminalsError)
        );
    }
    private _onLoadTerminalsResponse(response: Array<any>) {
        this.terminalsRegistry = response;


        this.hourGlassEnd(this.inputTerminal);
        let targetValue = this.terminalID;

        if (!targetValue) {
            if (response.length == 1) targetValue = response[0];
        }
        let result = false;
        //for (let entity of response) {
        //    if (entity.ID == terminalID) {
        //        result = true;
        //        break;
        //    }
        //}

        //if (result != true) {
        //    this.terminalID = null;
        //}


        this.inputTerminal.setSelectionListLEGACY(response);
        this.inputTerminal.setValue(targetValue, result);

    }

    private _onLoadTerminalsError(error: more.requestErrorMessage) {
        //alert(error.Message);
        this.showMessage("loading terminals failed", error.Message, true);

        this.hourGlassEnd(this.inputTerminal);
    }

    _setTerminalAttr(ID: string) {
        this._onChange_InputTerminal(ID);
    }
    setStep1Data(divisionID: string, terminalID: string, transportGoodID: string) {

        this.terminalID = terminalID;

        if (this.divisionID != divisionID) {
            this.divisionID = divisionID;
            this.inputDivision.setValue(divisionID, true);
        }

        if (this.transportGoodID != transportGoodID && !transportGoodID) {
            this.setTransportGood(null);
            return;
        }

        this.transportGoodID = transportGoodID;
        this.inputTransportGood.setValue(transportGoodID, true);

        this.disableNode(this.sectionStep2, !this.divisionID || !this.terminalID);

        this.disableNode(this.inputTerminal, this.divisionID == null);

        if (this.divisionID && !this.terminalID) {
            this.mainRouteID = null;
        }


        this.step1_Valid = false;
        this.step1_Summary = "";

        //console.debug("step1Data", this.terminalID, this.divisionID);

        if (this.terminalID && this.divisionID) {
            this.loadLogisticResources();
            //this.loadMainRoutes(); // wird nun erst geladen wenn die logisticResourceID vorhanden ist
            this.inputTransportGood.setCallfunction("Webtool_API_TransportIntermodal__GetTransportGoods");
            this.inputTransportGood.setRequestParameter("terminalID", this.terminalID);
            this.inputTransportGood.setRequestParameter("divisionID", this.divisionID);
            this.inputTransportGood.setRequestParameter("selectedTransportGoodID", this.transportGoodID);

            //this.inputTransportGood.loadListValues(this.transportGood, true);
            this.loadTransportGoods();

            let transportGoodLine1 = "";
            let transportGoodLine2 = "";
            if (this.transportGood) {
                transportGoodLine1 = this.transportGood.order_number;
                //transportGoodLine2 = this.transportGood
            }

            let divisionLabel = "";
            for (let division of this.divisionsRegistry) {
                if (division.ID == this.divisionID) {
                    divisionLabel = division.name_address;
                    break;
                }
            }

            let terminalLabel = "";
            for (let terminal of this.terminalsRegistry) {
                if (terminal.ID == this.terminalID) {
                    terminalLabel = terminal.name_address;
                    break;
                }

            }

            this.step1_Valid = true;
            this.step1_Summary = this.stringFormat("{0}<br>{1}", divisionLabel, terminalLabel);
            if (this.transportGood) {
                this.step1_Summary = this.stringFormat("{0}<br>{2}: {1}", this.step1_Summary, transportGoodLine1, this.translate("TiBooking__OrderNo"));
            }
        }

        this.emit("changeStep1");

        if (this.bookingMode != "rebook") {
            this.setStep2Data(null);
        }

    }

    private _onChange_InputTerminal(value: string) {
        this.setStep1Data(this.divisionID, value, this.transportGoodID);

        localStorage.setItem("Ti_TerminalID", value);
    }


    private loadMainRoutes(): void {

        this.inputMainRoute.StandbyStart();

        this.disableNode(this.sectionStep3);
        //this.disableNode(this.btnCreateCustomRoute);

        var url = window.appRoot + "TransportIntermodal/GetMainRoutes";

        let data = {
            "divisionID": this.divisionID,
            "terminalID": this.terminalID,
            "logisticResourceID": this.logisticResourceID
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadMainRoutesResponse),
            lang.hitch(this, this._onLoadMainRoutesError),
            false // sync
        );
    }

    private _onLoadMainRoutesResponse(response: Array<TiEntities.MainRoute_Minimal>) {
        this.inputMainRoute.StandbyStop();

        this.disableNode(this.sectionStep3, false);

        this.inputMainRoute.setSelectionListLEGACY(response);

        if (this.formData && this.bookingMode == "rebook") {
            this.inputMainRoute.setValue(this.formData.mainRouteID);
        }

        else if (response.length == 1) {

            this.inputMainRoute.setValue(response[0].ID);
        } else {
            if (this.mainRouteID && this.inputMainRoute.optionExists(this.mainRouteID)) {
                this.inputMainRoute.setValue(this.mainRouteID);
                //this.disableNode(this.btnCreateCustomRoute, !this.mainRouteID);
                this.pageStack_route.disablePage("custom", !this.mainRouteID);
                this.pageStack_route.disablePage("slot", !this.mainRouteID);
            } else {
                this.inputMainRoute.setValue(null);
            }
        }

    }

    private _onLoadMainRoutesError(error: more.requestErrorMessage) {
        //alert(error.Message);
        this.showMessage("loading main routes failed", error.Message, true);

        this.StandbyStop();
    }


    private _onChange_LogisticResources(value: Array<string>) {
        if (value && value.length == 1) {
            this.setStep2Data(value[0]);
        } else {
            this.setStep2Data(null);
        }
    }

    private setStep2Data(logisticResource: string) {

        this.logisticResourceID = logisticResource;

        if (this.logisticResourceID) {
            this.loadMainRoutes();
        }

        this.logisticResource = null;

        this.step2_Valid = false;
        this.step2_Summary = "";

        if (this.logisticResourceID) {

            let trailerLabel = "";
            for (let trailer of this.logisticResourcesRegistry) {
                if (trailer.slotID == this.logisticResourceID) {
                    this.logisticResource = trailer;
                    trailerLabel = trailer.summary;

                    break;
                }
            }

            this.step2_Valid = true;
            this.step2_Summary = trailerLabel;

            //if (this.mainRouteID && this.bookingMode != "rebook") {
            //    this.loadRouteResources();
            //}

        }

        this.UiModder.domClass.toggle(this.sectionStep3, "w3-disabled", !this.step2_Valid);
        this.emit("changeStep2");

    //    if (this.bookingMode != "rebook") {
    //        this.setStep3Data(this.mainRouteID, null);
    //    }
    }

    private _onChange_InputMainRoute(value: string) {
        //console.debug("_onChange_InputRoute", value, this.logisticResourceID);

        //this.routeSectionCombinator = null;
        this.setStep3Data(value, null);
    }

    private loadRouteResources(): void {

        this.StandbyStart(this.slotpickerContainer_route);

        var url = window.appRoot + "TransportIntermodal/GetRouteTimeslots";
        let data = {
            "divisionID": this.divisionID,
            "terminalID": this.terminalID,
            "mainRouteID": this.mainRouteID,
            "bookingID": this.entityID,
            "logisticResourceID": this.logisticResourceID,
            "showEmptyDays": this.cbShowEmptyDaysOnRouteSlots.getValue() !== false
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadRouteResourcesResponse),
            lang.hitch(this, this._onLoadRouteResourcesError),
            false // sync
        );
    }

    private _onLoadRouteResourcesResponse(response: {
        resourcepickerData: ResourcePicker.ResourcePickerConfiguration,
        resources: Array<TiInterfaces.RouteResource>
    }) {
        this.StandbyStop();


        this.routeResourcesRegistry = response.resources;

        this.UiModder.domConstruct.empty(this.slotpickerContainer_route);
        this.hideNode(this.slotpickerContainer_route, false);

        this.routeResourcesPicker = new ResourcePicker;
        response.resourcepickerData.labelEmptyGroupContent = true;

        this.routeResourcesPicker.setBaseUnits(3, 1.2, null, "150vh");
        this.routeResourcesPicker.setLayout(null, "fullwidth");
        this.routeResourcesPicker.placeAt(this.slotpickerContainer_route);
        this.routeResourcesPicker.setConfiguration(response.resourcepickerData);

        this.routeResourcesPicker.setTooltipClickFct(lang.hitch(this, this._onClick_RouteResourceTooltip));

        this.routeResourcesPicker.adjustHeightFactorToContent(3, 0.5);

        on(this.routeResourcesPicker, "change", lang.hitch(this, this._onChange_RouteResources));

    }

    private _onClick_RouteResourceTooltip(resource: ResourcePicker.ResourceEntry, content: string) {
        //console.debug("_onClick_RouteResourceTooltip", resource, content, this.routeResourcesRegistry);

        for (let entry of this.routeResourcesRegistry) {
            if (entry.slotID == content) {
                let dlg = new GenericDialog();
                dlg._setHeaderAttr(entry.displayname);
                dlg.setCloseOnEscape(true);
                dlg._setTopCloseBtnAttr(true);
                dlg._setCloseBtnAttr(true);
                dlg.setCloseOnEnter(false);
                dlg._setContentAttr(entry.tooltip);

                dlg.show();
                break;
            }

        }
    }

    private _onLoadRouteResourcesError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showMessage("loading routes failed", error.Message, true);

    //    alert(error.Message);
    }

    private _onChange_ShowEmptyDaysOnRouteSlots(value: boolean) {
        this._onChange_RouteResources(null);
        if (this.mainRouteID) {
            this.loadRouteResources();
        }
    }

    private _onChange_RouteResources(values: Array<string>) {

        if (values && values.length == 1) {
            this.setStep3Data(this.mainRouteID, values[0]);
        } else {
            this.setStep3Data(this.mainRouteID, null);
        }
    }

    private _setupRoutePagestack() {
        this.pageStack_route = new PageStack();
        this.pageStack_route.placeAt(this.pageStackContainer_route, "only");

        this.pageStack_route.on("pageActivated", lang.hitch(this, this._onPageStack_Route_PageChange));

        this.pageStack_route.addPage(this.page_routeSlots, {
            label: "TiBooking_PageLabel_SelectRouteSlot",
            iconclass: "fas fa-th",
            name: "slot"
        });

        if (this.hasUserRole("TI_CustomRoute")) {
            this.pageStack_route.addPage(this.page_customRoute, {
                label: "TiBooking__Heading_CustomRoute",
                iconclass: "fas fa-edit",
                name: "custom",
                enabled: false
            });
        }

        this.pageStack_route.addPage(this.page_routeView, {
            label: "TiBooking_PageLabel_SelectedRoute",
            name: "routeview",
            iconclass: "fas fa-route",
            enabled: false
        });
    }

    private routeSectionCombinator: MdsLax<InstanceType<typeof TiRouteSectionCombinator>>;
    private _onPageStack_Route_PageChange(newPageName: string) {
    //    if (newPageName == "custom" && !this.routeSectionCombinator) {
    //        this.setupCustomRouteCombinator(this.mainRouteID);
    //    }
    }

    private setStep3Data(mainrouteID: string, routeslotID: string, dummyRouteSlot?: TiEntities.MainRouteTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension) {

        if (this.mainRouteID != mainrouteID) {
            this.setupCustomRouteCombinator(mainrouteID);
        }

        this.mainRouteID = mainrouteID;
        this.routeslotID = routeslotID;

        this.hideNode(this.pageStackContainer_route, !this.mainRouteID);
        this.hideNode(this.slotpickerContainer_route, !this.mainRouteID);
        this.hideNode(this.removeRouteContainer, !this.routeslotID);


        if (this.pageStack_route) {
            this.pageStack_route.enablePage("slot", !!this.mainRouteID && !this.routeslotID);
            this.pageStack_route.enablePage("custom", !!this.mainRouteID && !this.routeslotID);
            this.pageStack_route.enablePage("routeview", !!this.routeslotID)

            this.pageStack_route.hidePage("custom", !this.hasUserRole("TI_CustomRoute"));

            this.pageStack_route.hidePage("routeview", !this.routeslotID);

            this.pageStack_route.switchToPage("routeview");

        }

        //this.disableNode(this.btnCreateCustomRoute, !this.mainRouteID);

        if (this.entityID && this.bookingMode != "rebook") return;

        if (this.mainRouteID && !this.routeslotID && this.logisticResourceID) {
            this.loadRouteResources();
        }

        this.step3_Valid = false;
        this.step3_Summary = "";
        this.UiModder.domClass.add(this.routeResourceWarning, "w3-hide");
        this.UiModder.domAttr.set(this.routeResourceWarning, "innerHTML", "");

        let routeLabel = "";
        let selectedRoute: TiInterfaces.RouteResource = null;



        if (dummyRouteSlot) {

            this.routeResourcesPicker.setValue(null, true);
            this.isCustomMainRoute = true;
            //this.disableNode(this.btnCreateCustomRoute);
            //this.disableNode(this.btnRemoveCustomRoute, false);
            //this.hideNode(this.btnRemoveCustomRoute, false);

            let view = new TiMainRouteView();
            view.placeAt(this.routeViewContainer, "only");

            view.setData(dummyRouteSlot,
                null,
                {
                    sectionsConfig: {
                        highlight: false,
                        showExtendedInformation: true,
                        enableBookingStatus: false
                    }
                });


            selectedRoute = {
                bookingNote: null,
                summary: dummyRouteSlot._placeholderLabel,
                displayname: dummyRouteSlot._placeholderLabel,
                enableBooking: true
            } as any;
            routeLabel = selectedRoute.displayname;

        } else {
            if (this.routeslotID) {
                for (let route of this.routeResourcesRegistry) {
                    if (route.slotID == this.routeslotID) {
                        selectedRoute = route;
                        routeLabel = route.summary;

                        let view = new TiMainRouteView();
                        view.placeAt(this.routeViewContainer, "only");

                        view.loadMainRouteById(this.routeslotID, {
                            sectionsConfig: {
                                showExtendedInformation: true
                            }
                        });

                        this.isCustomMainRoute = false;

                        break;
                    }
                }
            }
        }

        if (this.mainRouteID && this.routeslotID && selectedRoute) {
            this.step3_Valid = selectedRoute.enableBooking;
            this.step3_Summary = routeLabel;
        } else {

        }

        if (selectedRoute && selectedRoute.enableBooking != true) {
            if (selectedRoute.bookingNote) {
                this.UiModder.domClass.remove(this.routeResourceWarning, "w3-hide");
                this.UiModder.domAttr.set(this.routeResourceWarning, "innerHTML", this.stringReplaceAll(selectedRoute.bookingNote, "\n", "<br>"));

                this.routeResourceWarning.scrollIntoView({
                    behavior: "smooth"
                });

            }
        }


        this.emit("changeStep3");

        this.serializeData();

        this.UiModder.domClass.toggle(this.sectionStep4, "w3-disabled w3-hide", !this.step3_Valid);

        if (this.bookingMode == "rebook") {
            if (typeof (this.formData?.offloadingValue) == "number") {
                this.setStep4Data(this.formData.offloadingValue.toString());
            }
        } else {

        }
    }

    private _onClick_RemoveRoute(evt: MouseEvent) {
        this.resetSelectedRoute();
    }

    private resetSelectedRoute() {
        this.hideNode(this.removeRouteContainer);

        this.setStep3Data(this.mainRouteID, null, null);
        //this.disableNode(this.btnRemoveRoute);

        this.routeResourcesPicker.setValue(null, true);
    }

    private loadLogisticResources(): void {

        this.StandbyStart(this.sectionStep2);

        var url = window.appRoot + "TransportIntermodal/GetLogisticResources";

        let data = {
            "divisionID": this.divisionID,
            "terminalID": this.terminalID
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadLogisticResourcesResponse),
            lang.hitch(this, this._onLoadLogisticResourcesError),
            false // sync
        );
    }

    private _onLoadLogisticResourcesResponse(response: {
        resourcepickerData: ResourcePicker.ResourcePickerConfiguration,
        resources: Array<TiEntities.LogisticResource>,
        offloading: Array<OffloadingEntry>
    }) {
        this.StandbyStop();

        if (response.offloading) {
            this._setupOffloading(this.offloading?.toString(), response.offloading);
        }


        this.UiModder.domConstruct.empty(this.slotpickerContainer_logistic);

        this.logisticResourcesRegistry = response.resources;
        this.logisticResourcesGroupsRegistry = response.resourcepickerData.groups;

        this.logisticResourcesPicker = new ResourcePicker;
        response.resourcepickerData.labelEmptyGroupContent = true;
        this.logisticResourcesPicker.setConfiguration(response.resourcepickerData);
        this.logisticResourcesPicker.setBaseUnits(2, 1);
        //this.logisticResourcesPicker.setLayout(null, "fixedCentered");
        this.logisticResourcesPicker.setLayout(null, "fullwidth");

        this.logisticResourcesPicker.placeAt(this.slotpickerContainer_logistic);

        this.logisticResourcesPicker.adjustHeightFactorToContent(3, 0.5);


        this.logisticResourcesPicker.setTooltipClickFct(lang.hitch(this, this._onClick_LogisticResourceTooltip));

        on(this.logisticResourcesPicker, "change", lang.hitch(this, this._onChange_LogisticResources));


    }

    private _onClick_LogisticResourceTooltip(resource: any, content: string) {
        //console.debug("_onClick_LogisticResourceTooltip", content, this.logisticResourcesRegistry);
        // es kann beides daherkommen, also wenn das passende Entry gefunden ist mit return raus!

        let clickedGroup = <ResourcePicker.GroupDescriptor>resource;
        let clickedEntry = <ResourcePicker.ResourceEntry>resource;

        if (clickedEntry.value) { // Gruppen haben keine value, also wenn wir hier reinkommen ist es ein Entry
            for (let entry of this.logisticResourcesRegistry) {
                if (entry.slotID == content) {
                    let dlg = new GenericDialog();
                    dlg._setHeaderAttr(entry.displayname);
                    dlg.setCloseOnEscape(true);
                    dlg._setTopCloseBtnAttr(true);
                    dlg._setCloseBtnAttr(true);
                    dlg.setCloseOnEnter(false);
                    dlg._setContentAttr(entry.tooltip);

                    dlg.show();
                    return;
                }
            }
        } else {
            for (let group of this.logisticResourcesGroupsRegistry) {

                if (group.groupValue == clickedGroup.groupValue) {
                    let dlg = new GenericDialog();
                    dlg._setHeaderAttr(this.stringFormat("{0} {1}", group.label, group.secondaryLabel));
                    dlg.setCloseOnEscape(true);
                    dlg._setTopCloseBtnAttr(true);
                    dlg._setCloseBtnAttr(true);
                    dlg.setCloseOnEnter(false);
                    dlg._setContentAttr(content);

                    dlg.show();
                    return;
                }

            }
        }



    }

    private _onLoadLogisticResourcesError(error: more.requestErrorMessage) {
        //alert(error.Message);
        this.showMessage("loading logistics failed", error.Message, true);

        this.StandbyStop();
    }

    private _onChange_InputOffloading(value: string) {
        this.setStep4Data(value);
    }

    private setStep4Data(offloadingValue: string) {
        if (offloadingValue && offloadingValue != "-1") {
            this.offloading = parseInt(offloadingValue);
            this.step4_Valid = this.step1_Valid && this.step2_Valid && this.step3_Valid && true;
            switch (offloadingValue) {
                case "1":
                    this.step4_Summary = "1 Tag";
                    break;

                case "2":
                    this.step4_Summary = "2 Tage";
                    break;

                default:
                    this.step4_Summary = "??";
                    break;
            }

        } else {
            this.step4_Valid = false
            this.step4_Summary = "";

            this.offloading = null;
        }
        this.emit("changeStep4");

        this.serializeData();


        if (this.bookingMode != "rebook") {
        } else {
            this.UiModder.domClass.toggle(this.btnRebook, "w3-disabled w3-hide", !this.step4_Valid);
            this.disableNode(this.inputOrderNo);
        }

        this.UiModder.domClass.toggle(this.sectionBookingConfirmation, "w3-disabled w3-hide", !this.step4_Valid);
    }



    private serializeData(resetDirty?: boolean) {
        //if (this.entityID) {
        //    return;
        //}

        this.formData = {
            ID: this.entityID,
            customMainRouteData: this.isCustomMainRoute ? this.routeSectionCombinator?.getCustomRouteSaveData() : null,
            is_cancelled: this.isCancelled,
            logisticResourceID: this.logisticResourceID,
            routeSlotID: this.routeslotID,
            mainRouteID: this.mainRouteID,
            divisionID: this.divisionID,
            terminalID: this.terminalID,
            offloadingValue: this.offloading,
            orderNo: this.orderNo,
            transportGoodID: this.transportGoodID,
            mode: null,
            additionalTransportGoods: [],//this.transportGoodsManager.getTransportGoodIDs()
            //summaryDivision: this.step1_Summary,
            //summaryLogisticResource: this.step2_Summary,
            //summaryRoute: this.step3_Summary,
            //summaryOffloading: this.step4_Summary
        };



        //console.debug("data serialized", this.formData);

        let currentFormdata = JSON.stringify(this.formData);

        if (currentFormdata != this.previousFormdata) {
            this.emit("change", this.formData);

            if (resetDirty === true) {
                this.previousFormdata = currentFormdata;
            }
        }

        if (this.formData.ID == null) {
            this.setSummaries();
        }
    }

    private _keyUpEvtHandle: any = null;
    private _onKeyUp_InputOrderNo(evt: KeyboardEvent) {
        if (this._keyUpEvtHandle != null) {
            clearTimeout(this._keyUpEvtHandle);

        }
        this._keyUpEvtHandle = setTimeout(lang.hitch(this, this._onChange_InputOrderNo), 200);
    }


    private _onChange_InputOrderNo(evt: Event) {

        this._keyUpEvtHandle = null;

        if (!this.inputOrderNo.value) {
            this.orderNo = null;
        }
        else {
            this.orderNo = this.inputOrderNo.value;
        }

        this.serializeData();


        if (evt) {

        }

    }



    private _onClick_Book(evt: MouseEvent) {
        //if (!this.orderNo) return;
        if (!this.transportGoodID) return;

        if (!this.step1_Valid ||
            !this.step2_Valid ||
            !this.step3_Valid ||
            !this.step4_Valid) {
            return;
        }
        this.formData.mode = "book";
        this.formData.orderNo = this.orderNo;

        this.UiModder.domClass.add(this.btnBook, "w3-disabled");

        if (this.entityID) {
            this.confirmBooking();
        }
        else {
            this.saveBooking();
        }
    }

    private _onClick_Rebook(evt: MouseEvent) {
        if (!this.entityID) return;

        // ICH BIN der Umbuchungsdialog
        if (this.bookingMode == "rebook") {
            this.formData.mode = "rebook";
            //console.log("rebook click", this.formData);

            //this.UiModder.domClass.add(this.progressBar, "ego_animated_progressBar");
            //this.UiModder.domClass.remove(this.progressBar, "w3-hide");

            this.rebookBooking();
        }

        // ich bin eine Buchung, die umgebucht gehört -> neues Formular im Dialog öffnen
        else {

            let rebookingForm = new TiBookingForm;
            rebookingForm.startAsRebooking(this.formData);

            let dlg = new GenericDialog();
            dlg._setHeaderAttr(this.stringFormat(this.translations["TiBooking__Dlg_Rebooking_Header"], this.entity.displayname));
            dlg.addNodeToContent(rebookingForm.domNode);
            dlg._setTopCloseBtnAttr(true);
            dlg._setCancelBtnAttr(true);
            //dlg._setCloseBtnAttr(true);
            dlg.show();

            this.UiModder.domClass.add(this.sectionBookingConfirmation, "w3-disabled");

            on(rebookingForm, "rebookingComplete", lang.hitch(this, this._onRebookingComplete, dlg));
            dlg._setCallbackAttr(lang.hitch(this, this._onRebookingClosed));
        }
    }

    private _onRebookingComplete(rebookingDlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        // der geöffnete Dialog hat gemeldet, dass er fertig ist und kann jetzt zu,
        // wir sind zurück in der vorherigen Buchungsansicht
        // die ist jetzt "obsolet" und sollte neu geladen werden

        this.UiModder.domClass.add(this.sectionBookingConfirmation, "w3-hide");
        this.UiModder.domClass.add(this.sectionBookingSummary, "w3-disabled");

        rebookingDlg.close();

        this.emit("bookingUpdated"); // löst neuladen am Listenwidget aus
        //
    }

    private _onRebookingClosed(result: number) {
        if (this.sectionBookingConfirmation) { // kann kaputt sein, wenn nach dem booking-Update schon eine neue Instanz daherkommt
            this.UiModder.domClass.remove(this.sectionBookingConfirmation, "w3-disabled");
        }
    }



    private _onClick_Reserve(evt: MouseEvent) {
        if (!this.step1_Valid ||
            !this.step2_Valid ||
            !this.step3_Valid ||
            !this.step4_Valid) {
            return;
        }

        this.formData.mode = "reserve";

        this.saveBooking();

        this.UiModder.domClass.add(this.btnReserve, "w3-disabled");
    }

    private _onClick_Cancel(evt: MouseEvent) {
        if (!this.entityID) {
            return;
        }

        let dlg = new GenericDialog;
        dlg._setYesBtnAttr(true);
        dlg._setNoBtnAttr(true);

        dlg._setHeaderAttr(this.stringFormat(this.translate("TiBooking__Dlg_CancelBooking_Header"),
            this.formData.mode, this.entity?.displayname ? this.entity.displayname : ""));
        dlg._setContentAttr(this.stringFormat(this.translate("TiBooking__Dlg_CancelBooking_Message"),
            this.formData.mode, this.entity?.displayname ? this.entity.displayname : ""));

        dlg._setCallbackAttr(lang.hitch(this, this._onCancelDlgResult));

        dlg.show();
    }

    private _onCancelDlgResult(result: number) {

        if (result <= 0) {
            return;
        }

        //let newData: TransportIntermodal.BookingFormData = {
        //    ID: this.formData.ID,
        //    logisticResourceID: this.formData.logisticResourceID,
        //    divisionID: this.formData.divisionID,
        //    mode: "cancel",
        //    mainrouteID: this.formData.mainrouteID,
        //    terminalID: "",
        //    routeSlotID: "",
        //    orderNo: "",
        //    is_cancelled: false,
        //    offloading: -1
        //};
        //this.formData.mode = "cancel";
        //this.saveBooking();
        this.cancelBooking();
        this.UiModder.domClass.add(this.btnCancel, "w3-disabled");
        this.isCancelled = true;

    }


    private setupCustomRouteCombinator(mainrouteID: string) {

        this.UiModder.domConstruct.empty(this.customRouteContainer);
        this.routeSectionCombinator = null;
        let currentPage = this.pageStack_route.getActivePageName();

        if (!this.hasUserRole("TI_CustomRoute")) return;

        /*if (currentPage == "custom") debugger;*/

        if (!mainrouteID || !this.logisticResourceID /*|| currentPage != "custom"*/) return;

        let mainRouteName = this.inputMainRoute.getDisplayValue();
        //let dlg = new GenericDialog();
        //dlg.setSize("fullsize");

        let routeCombinator = new TiRouteSectionCombinator();
        routeCombinator.placeAt(this.customRouteContainer);

        //dlg.show(routeCombinator,
        //    mainRouteName,
        //    null,
        //    null,
        //    "submitcancel",
        //    lang.hitch(this, this._onCustomRouteCallback, routeCombinator));

        //dlg.disableButton("submit");

        //routeCombinator.on("valid", lang.hitch(this, this._onCustomRouteValid, dlg));

        routeCombinator.setup(mainrouteID, this.logisticResourceID);

        this.routeSectionCombinator = routeCombinator;

        routeCombinator.on("valid", lang.hitch(this, this._onCustomRouteValid, routeCombinator));

    }

    //private _onCustomRouteValid(dlg: GenericDialog, bValid: boolean) {
    //    dlg.enableButton("submit", bValid);
    //}

    private _onCustomRouteValid(routeCombinator: MdsLax<InstanceType<typeof TiRouteSectionCombinator>>, bValid: boolean) {
        if (bValid == true) {
            this._onCustomRouteCallback(routeCombinator, 1);
        } else {
            this.resetSelectedRoute();
        }
    }

    private _onCustomRouteCallback(routeCombinator: MdsLax<InstanceType<typeof TiRouteSectionCombinator>>, result: number) {
        if (result <= 0) return;

        let dummyroute = routeCombinator.getCustomRouteSlot();

        if (dummyroute) {
            this.setStep3Data(this.mainRouteID, dummyroute.ID, dummyroute);
        }

    }


    private rebookBooking() {
        this.StandbyStart();
        var url = window.appRoot + "TransportIntermodal/RebookBooking";

        this.UiModder.domClass.add(this.btnRebook, "w3-disabled");


        let data = this.formData;

        data.mode = "rebook";

        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onRebookingResponse),
            lang.hitch(this, this._onRebookingError),
            false // sync
        );
    }

    private cancelBooking() {
        this.StandbyStart();
        var url = window.appRoot + "TransportIntermodal/CancelBooking";

        let data = { "bookingID": this.entityID };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onCancelBookingResponse),
            lang.hitch(this, this._onCancelBookingError),
            false // sync
        );
    }

    private confirmBooking() {
        this.StandbyStart();
        var url = window.appRoot + "TransportIntermodal/ConfirmBooking";

        let data = { "bookingID": this.entityID, "transportGoodID": this.transportGoodID, "orderNo": this.transportGood?.order_number };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onConfirmBookingResponse),
            lang.hitch(this, this._onConfirmBookingError),
            false // sync
        );
    }

    private saveBooking() {
        this.StandbyStart(this.sectionBookingConfirmation);
        this.disableNode(this.sectionStep1);
        this.disableNode(this.sectionStep2);
        this.disableNode(this.sectionStep3);
        this.disableNode(this.sectionStep4);
        this.disableNode(this.sectionBookingConfirmation);
        var url = window.appRoot + "TransportIntermodal/SaveBooking";

        let data = this.formData;
        let stringData = JSON.stringify(data);

        if (this.hasUserRole("_DEV")) {
            console.debug("save booking form data", data, stringData);
            if (confirm("confirm save?") != true) {
                this._onSaveBookingError({ Message: "saving cancelled" } as any);
                return;
            }
        }

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onSaveBookingResponse),
            lang.hitch(this, this._onSaveBookingError),
            false // sync
        );
    }

    private _onSaveBookingResponse(response: TiEntities.BookingEntityData) {
        this.UiModder.domClass.remove(this.btnCancel, "w3-disabled");
        this.UiModder.domClass.remove(this.btnBook, "w3-disabled");
        this.UiModder.domClass.remove(this.btnReserve, "w3-disabled");
        this.StandbyStop();
        this.disableNode(this.sectionStep1);
        this.disableNode(this.sectionStep2);
        this.disableNode(this.sectionStep3);
        this.disableNode(this.sectionStep4);
        this.disableNode(this.sectionBookingConfirmation, false);

        if (this.bookingMode == "rebook") {
            this.emit("rebookingComplete");
        }

        else {
            if (response.mode as any == "Reservierung") { // hier ist der Wert von "mode" abweichend zum Interface?
                // direkt zur Übersicht (keine Entladeliste)
                this.step5_Valid = true;
                this.emit("changeStep5");

                setTimeout(lang.hitch(this, function () { // keine ahnung warum aber sonst gehts nit. der 5er muss vorher gesetzt sein und dann kurz drauf der 6er
                    this.step6_Valid = true;
                    this.UiModder.domClass.remove(this.sectionBookingSummary, "w3-hide");
                    this.emit("changeStep6");
                }), 100)

            } else {
                //  Buchung muss IMMER disponiert werden (Entladeliste)
                //
                this.step5_Valid = true;
                this.emit("changeStep5");
                this.hideNode(this.sectionDispo, false);
                this.UiModder.domClass.remove(this.sectionBookingSummary, "w3-hide");
                //this.UiModder.domAttr.set(this.bookingSummaryContainer, "innerHTML", response.summary);

                this.unloadingList.unloadingForm.divisionID = this.divisionID;
                this.unloadingList.unloadingForm.terminalID = response.unloadingTerminalID;
                this.unloadingList.unloadingForm.bookingID = response.ID;
                this.unloadingList.unloadingForm.setFilterDate(new Date(response.dateEnd));
                this.unloadingList.unloadingForm.autonavigate();
            }

        }

        this.setSummaries(response);
    }

    private _onSaveBookingError(error: more.requestErrorMessage) {
        this.UiModder.domClass.remove(this.btnBook, "w3-disabled");
        this.UiModder.domClass.remove(this.btnReserve, "w3-disabled");
        this.StandbyStop();
        this.disableNode(this.sectionStep1, false);
        this.disableNode(this.sectionStep2, false);
        this.disableNode(this.sectionStep3, false);
        this.disableNode(this.sectionStep4, false);
        this.disableNode(this.sectionBookingConfirmation, false);

        this.step5_Valid = false;
        this.emit("changeStep5");
        this.UiModder.domClass.add(this.sectionBookingSummary, "w3-hide");

        this.showMessage("saving failed", error.Message, true);
    }

    private _onConfirmBookingError(error: more.requestErrorMessage) {
        this._onCancelBookingError(error);
    }

    private _onCancelBookingError(error: more.requestErrorMessage) {
        this.UiModder.domClass.remove(this.btnBook, "w3-disabled");
        this.UiModder.domClass.remove(this.btnReserve, "w3-disabled");
        this.UiModder.domClass.remove(this.btnCancel, "w3-disabled");
        this.StandbyStop();

        this.showMessage("saving failed", error.Message, true);
    }

    private _onRebookingError(error: more.requestErrorMessage) {
        this.UiModder.domClass.remove(this.btnRebook, "w3-disabled");
        //this.UiModder.domClass.remove(this.progressBar, "ego_animated_progressBar");

        this.StandbyStop();

        this.showMessage("rebooking failed", error.Message, true);
    }

    private _onConfirmBookingResponse(response) {
        this.emit("bookingConfirmed");
        this.StandbyStop();
    }
    private _onCancelBookingResponse(response) {
        this.emit("bookingCancelled");
        this.StandbyStop();
    }
    private _onRebookingResponse(response) {
        this.StandbyStop();
        this.emit("rebookingComplete");
    }


    showMessage(title: string, message: string, bIsError?: boolean, icon?: string) {
        let dlg = new GenericDialog();
        dlg._setHeaderAttr(title);
        dlg._setContentAttr(message);

        if (bIsError === true) {
            dlg._setTextIconAttr("fas fa-tired");
        }
        if (icon) {
            dlg._setTextIconAttr(icon);
        }

        dlg._setOkBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg.setCloseOnEnter(false);

        dlg.show();

    }

    private setSummaries(data?: TiEntities.BookingEntityData) {
        if (data) {

        } else {

            let tgList = [];//.transportGoodsManager.getTransportGoods();
            let mainTG = this.inputTransportGood.getValue(true);
            if (mainTG) tgList.push(mainTG);

            data = {
                ...this.formData,
                ID: null,
                logisticResourceLDM: this.logisticResource?.LDM,
                division: this.inputDivision.getDisplayValue(),
                terminal: this.inputTerminal.getDisplayValue(),
                transportGood: this.inputTransportGood.getValue(true),
                transportGoods: tgList,
                logisticResourceTXT: this.step2_Summary,
                logisticResource: this.logisticResource,
                mode: this.formData.mode,
                route: this.step3_Summary,
                offloading: this.step4_Summary,
                orderNo: this.orderNo
            };
        }

        this.entity = data;
        this.bookingSummary.setData(data);

        if (this.transportGoodsManager) {
            this.transportGoodsManager.setupFromBooking(data);
        }
    }

    private startAsRebooking(data: TiInterfaces.BookingFormData) {
        if (!data || !data.ID) {
            return;
        }
        console.debug("startAsRebooking", data);


        this.inputOrderNo.value = data.orderNo;

        this.setFormData(data);

        this.bookingMode = "rebook";
        this.UiModder.domClass.add(this.domNode, "rebooking");
        this.UiModder.domClass.add(this.btnRebook, "accentBG");
        this._setupOffloading(data.offloadingValue.toString());

        this.inputMainRoute.setReadonly(true);
        //this.inputMainRoute.setVisible(false);
        this.setStep1Data(data.divisionID, data.terminalID, data.transportGoodID);
        this.setStep2Data(data.logisticResourceID);
        this.setStep3Data(data.mainRouteID, data.routeSlotID);
        this.setStep4Data(data.offloadingValue.toString());

        this.loadTransportGoods();

        this.UiModder.domClass.add(this.sectionStep1, "w3-hide");
        this.UiModder.domClass.add(this.sectionStep2, "w3-hide");
        //this.UiModder.domClass.add(this.sectionStep3, "w3-hide");
        this.UiModder.domClass.add(this.sectionStep4, "w3-hide");
        this.UiModder.domClass.add(this.sectionBookingConfirmation, "w3-hide");

        this.UiModder.domClass.add(this.btnBook, "w3-hide");
        this.UiModder.domClass.add(this.btnCancel, "w3-hide");
        this.UiModder.domClass.add(this.btnReserve, "w3-hide");

        //this.UiModder.domClass.add(this.inputOrderNo, "w3-disabled");
    }

    private setFormData(data: TiInterfaces.BookingFormData) {
        this.entityID = data.ID;


        this.transportGoodID = data.transportGoodID;
        this.divisionID = data.divisionID;
        this.terminalID = data.terminalID;
        this.offloading = data.offloadingValue;
        this.mainRouteID = data.mainRouteID;
        this.routeslotID = data.routeSlotID;
        this.isCancelled = data.is_cancelled;
        this.logisticResourceID = data.logisticResourceID;
        this.orderNo = data.orderNo;

        this.formData = { ...data, customMainRouteData: null };

    }


    gotoBookingConfirmation(entity: TiEntities.BookingEntityData,
        useOwnSummary?: boolean) {
        if (!entity || !entity.ID) {
            return;
        }

        if (entity.logisticResource) this.logisticResource = entity.logisticResource;
        this.setTransportGood(entity.transportGood);


        this.setFormData(entity);

        //if (entity.transportGoods) {
        //    for (let tg of entity.transportGoods) {
        //        this.transportGoodsManager.addTransportGood(tg);
        //    }
        //}
        this.entity = entity;


        if (useOwnSummary !== false) {
            this.bookingSummary.setData(entity);
            this.hideNode(this.sectionBookingSummary, false);
        } else {

            this.hideNode(this.sectionBookingSummary);
        }

        //this.setStep1Data(data.divisionID, data.terminalID);
        //this.setStep2Data(data.logisticResourceID);
        //this.setStep3Data(data.mainrouteID, data.routeSlotID);
        //this.setStep4Data(data.offloading.toString());
        this.step1_Valid = true;
        this.step2_Valid = true;
        this.step3_Valid = true;
        this.step4_Valid = true;

        this.hideNode(this.sectionStep1);
        this.hideNode(this.sectionStep2);
        this.hideNode(this.sectionStep3);
        this.hideNode(this.sectionStep4);

        this.UiModder.domClass.toggle(this.sectionBookingConfirmation, "w3-hide", this.formData.is_cancelled);

        let bAllowBooking = entity.ID != null && !entity.is_cancelled && entity.bookingType == 1;
        let bAllowInputOrder = !(entity.orderNo || entity.is_cancelled);
        let bAllowAdditionalTransportGoods = !entity.is_cancelled;
        let bAllowCancel = entity.ID && !entity.is_cancelled && entity.bookingType == 1;


        //this.transportGoodsManager.setReadonly(!bAllowAdditionalTransportGoods);

        this.hideNode(this.inputOrderNo, !bAllowInputOrder);

        this.hideNode(this.btnBook, !bAllowBooking);
        this.hideNode(this.btnCancel, !bAllowCancel);

        this.hideNode(this.orderNoContainer, !bAllowInputOrder);

        if (bAllowInputOrder) {
            this.loadTransportGoods();
            this.inputTransportGood.setReadonly(false);
        }

        //this.hideNode(this.sectionAdditionalTransportGoods, !bAllowAdditionalTransportGoods);


        this.UiModder.domClass.toggle(this.btnRebook, "w3-hide w3-disabled", this.formData.ID == null ||
            (entity.is_rebooking_available != true ));
        this.hideNode(this.btnReserve, this.formData.ID != null);

    }

    getData(): TiInterfaces.BookingFormData {
        return this.formData;
    }

    private _onSaved_UnloadingList() {
        this.step6_Valid = true;
        this.emit("changeStep6");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.unloadingList.on("saved", lang.hitch(this, this._onSaved_UnloadingList))

        //this.additionalTransportGoodsStore = new EntityStore();
        //this.transportGoodsManager.on("change", lang.hitch(this, this._onChange_TransportGoodsManager));
        //this.transportGoodsManager.setReadonly(false);

        this.useStandbyManager = true;

        this.RequestManager.handleAs = "jsonWithDate";
        this.SEDconfigCallfunction = "Webtool_API_TransportIntermodal__GetSEDconfig"
        //this.inputTransportGood.addInlineButton(lang.hitch(this, this._onClick_OpenTransportGoodSED));



    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);

        if (this.formData) {

        } else {
            this.hasUserRole("dummy", lang.hitch(this, this._setupRoutePagestack));
            //this._setupRoutePagestack();
        }

        if (!this.divisionID || !this.terminalID) {
            this.terminalID = null;
            //this.divisionID = localStorage.getItem("Ti_DivisionID");

            this.UiModder.domClass.remove(this.sectionStep1, "w3-hide");
            this.loadDivisions();
        } else {
            this.loadLogisticResources();
        }

        this._setupOffloading();

    }

    private _setupOffloading(value?: string, entries?: Array<OffloadingEntry>) {
        if (entries) {
            let labels = [];
            let values = [];
            for (let entry of entries) {
                labels.push(entry.label);
                values.push(entry.value.toString());
            }

            this.inputOffloading.setOptions(values, labels);


        } else {
           this.inputOffloading.setOptions(["1", "2"], ["?", "??"]);
        }

        //this.inputOffloading._constructOptions();


        if (value) {
            this.inputOffloading.setValue(value, this.bookingMode == "rebook")
        }

    }

}

export default mdsWidget(TiBookingForm);
